let origin = window.ORIGIN;
//获取管理后台令牌
const getBackendToken = `${origin}/gateway/blade-user/user/getBackendToken`;
// 根据用户手机号获取管理后台令牌权限
const showBackendToken = `${origin}/gateway/blade-user/user/showBackendTokenMenu`;
export {
 getBackendToken,
 showBackendToken
};
